export const FOBTRADING_MODULE_NAME = "fobtrading_module";

export const fobtradingModuleMenuItem = {
  icon: "anchor",
  path: "/operacion/:proformId",
};

export const fobtradingModuleRoutes = [
  {
    path: "fobtrading/operacion/:proformId",
    redirect: (to) => ({
      name: "FobtradingOperacion",
      params: { proformId: to.params.proformId },
    }),
  },
  {
    path: "operacion/:proformId",
    name: "FobtradingOperacion",
    components: {
      default: () => import("./pages/Operacion.vue"),
    },
    meta: {
      title: "FOB Trading — Operación",
      requiresAuth: true,
      requiresModule: FOBTRADING_MODULE_NAME,
    },
  },
];

export default {
  moduleName: FOBTRADING_MODULE_NAME,
  routes: fobtradingModuleRoutes,
  menuItem: fobtradingModuleMenuItem,
};
